import React, { useEffect } from 'react';
import Loader from './layout/loader';

const RedirectPage = ({ pageRedirectPath, atParam }) => {
  useEffect(() => {
    const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
    let REACT_APP_OUTER_AUTHORIZE_URL = process.env.REACT_APP_OUTER_AUTHORIZE_URL;

    if (!REACT_APP_BASE_URL) {
      console.error('REACT_APP_BASE_URL не определена');
      return;
    }
    if (!REACT_APP_OUTER_AUTHORIZE_URL) {
      console.error('REACT_APP_OUTER_AUTHORIZE_URL не определена');
      return;
    }
    if (atParam) {
      REACT_APP_OUTER_AUTHORIZE_URL += `%20at:${atParam}`;
    }
    let redirectUrl = `${REACT_APP_OUTER_AUTHORIZE_URL}&redirect_uri=${REACT_APP_BASE_URL}${pageRedirectPath}`;
    
    // Добавляем параметр at в конец URL, если он присутствует
    
    
    /* console.log('Redirecting to:', redirectUrl); */

    window.location.href = redirectUrl;
  }, [pageRedirectPath, atParam]);

  return (
    <div className="loader-overlay">
      <Loader />
    </div>
  );
};

export default RedirectPage;